import React from "react";

const SettingsFilled = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
        <path
            d="M13.78.5v3.39c.905.217 2.275.573 3.047 1.045l2.397-2.396 2.952 2.952-2.396 2.395c.472.773.829 2.144 1.047 3.049h3.388v3.13h-3.387c-.22.905-.576 2.276-1.048 3.048l2.396 2.397-2.95 2.951-2.399-2.396c-.77.472-2.142.829-3.047 1.048V24.5h-3.13v-3.387c-.905-.22-2.276-.575-3.05-1.049l-2.395 2.397-2.952-2.95 2.397-2.398c-.472-.772-.829-2.143-1.048-3.048H.215v-3.13h3.387c.22-.905.576-2.276 1.048-3.048L2.253 5.49l2.952-2.952 2.397 2.396c.772-.472 2.143-.828 3.048-1.046V.5h3.13zm-1.565 7.304a4.696 4.696 0 100 9.392 4.696 4.696 0 000-9.392z"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
);

export default SettingsFilled;
